import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class MenuLink extends Component {
  render() {
    const { path, text, exact } = this.props;
    let link = <NavLink to={path} className="nav-link" activeClassName="active">{text}</NavLink>;
    if(exact) {
      link = <NavLink exact={true} to={path} className="nav-link" activeClassName="active">{text}</NavLink>;
    }

    return link;
  }
}

export default MenuLink;
